<template>
  <div class="flex flex-col w-full mb-2">
    <textarea class="metainputfield min-h-[75px]" placeholder="Einen Kommentar schreiben" v-model="comment"></textarea>
    <span class="flex flex-col w-full text-sm text-red-600" v-if="error">{{error}}</span>
  </div>

  <div class="flex w-full items-center justify-center mb-4">
    <button class="btn-default " @click.prevent="saveComment()">
      Speichern
    </button>
  </div>

  <div class="flex flex-col w-full mb-4">

    <blockquote class="comment" v-for="(item, index) in comments" v-bind:key="item">
      <span v-if="isdeleteable(item, index)" @click.prevent="removeComment(item)" class="absolute top-0 right-0 w-5 h-5 close-comment-btn"><img src="@/assets/icons/close.svg" /></span>
      <p>{{ item.content }}</p>
      <span class="absolute bottom-[-1rem] right-0.5 text-xs">{{formatDate(item.cr_date)}} von {{item.user}}</span>


    </blockquote>

  </div>

  <ConfirmationDialog title="Eintrag wirklich löschen?"
                      :item="delitem"
                      cancelbtn="Abbrechen"
                      submitbtn="Wirklich löschen!"
                      :show="showRemoveDialog"
                      @submit="removeComment"
                      @cancel="removeComment">
    <div class="mt-5 mb-5">
      <p>Möchten sie den Eintrag wirklich löschen?</p>
    </div>
  </ConfirmationDialog>
</template>

<script>
// import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import apiService from "@/services/collectionApiService";
import {toast} from "vue3-toastify";

export default {
  name: 'CollectionComments',
  components: {ConfirmationDialog},
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      comments: [],
      comment: '',
      error: '',
      showRemoveDialog: false,
      delitem: null
    }
  },
  mounted() {
    console.locallog('FileItem', this.item)
    this.loadcomments()
  },
  computed: {
  },
  methods: {

    isdeleteable(item, index) {
      console.locallog('Deletable Item', item, index)
      if(this.$store.state.currentuser.user.role == 'admin') {
        return true
      }

      if(this.comments.length -1 == index) {
        if(item.user == this.$store.state.currentuser.user.username ) {
          return true
        }
      }

      return false
    },

    async removeComment(item, action = null) {

      if(action == null) {
        this.delitem = item
        this.showRemoveDialog = true
      } else {

        console.locallog('Remove Item', action, item, this.item)

        if(action === true) {
            await apiService.removeComment({
              collection_id: this.item.id,
              id: item.id
            })
            .then((response) => {
              if(response.data.status == 'success') {
                this.comments = response.data.data.comments
                toast.success('Kommentar wurde erfolgreich gelöscht.')
              }
            })
            .catch((error) => {
              console.error('Es gab einen Fehler beim Senden des Post-Requests.', error);
            });
        }

        this.showRemoveDialog = false

      }
    },

    async loadcomments() {
      await apiService.getComments({
        collection_id: this.item.id})
      // await axios.post(process.env.VUE_APP_APP_APIURL + '/api/files/getcomments', {fileid: this.item.fileid})
        .then((response) => {
          this.comments = response.data.data.comments
        })
        .catch((error) => {
          console.error('Es gab einen Fehler beim Senden des Post-Requests.', error);
        })
    },
    async saveComment() {

      if(this.comment != '' && this.item.id != '') {

        await apiService.saveComment({
          collection_id: this.item.id,
          comment: this.comment
        })
            .then((response) => {

              if (response.data.status == 'error') {
                this.error = 'Kommentar konnte nicht erstellt werden'
                return
              }

              this.comments = response.data.data.comments
              this.comment = ''
              toast.success('Kommentar wurde erfolgreich gespeichert.')
            })
            .catch(() => {
              console.locallog('Error')
            })

      } else {
        this.error = 'Bitte einen Kommentar verfassen'
        setTimeout(() => {
          this.error = ''
        }, 2500)
      }
    }
  },
  watch: {
    item() {
      this.loadcomments()
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
